import React, { useState, useEffect, useRef, useCallback } from "react";
import { listPhotos, uploadPhotos, setCover, removePhoto } from "../../componentes/APIFOTO";
import { Api } from "../../componentes/Api";
import "./BibliotecaFoto.css";

const HOST = Api.replace(/\/api\/?$/, "");

export default function BibliotecaFoto({ recordID }) {
    const [photos, setPhotos] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileRef = useRef(null);

    const loadPhotos = useCallback(async () => {
        if (!recordID) {
            setPhotos([]);
            return;
        }

        setLoading(true);
        try {
            const data = await listPhotos(recordID);
            setPhotos(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Error cargando fotos:", err);
            setPhotos([]);
        } finally {
            setLoading(false);
        }
    }, [recordID]);

    useEffect(() => {
        loadPhotos();
    }, [loadPhotos]);

    const handleUpload = async (e) => {
        if (!recordID) {
            alert("Primero debes guardar el paciente para poder subir fotos.");
            return;
        }

        const files = Array.from(e.target.files || []);
        if (!files.length) return;

        setLoading(true);
        try {
            await uploadPhotos(recordID, files);
            await loadPhotos();
        } catch (err) {
            alert(err.message || "No se pudo subir la imagen");
        } finally {
            setLoading(false);
            e.target.value = "";
        }
    };

    const handleSetCover = async (photoId) => {
        try {
            await setCover(photoId);
            await loadPhotos();
        } catch (err) {
            alert(err.message || "No se pudo marcar portada");
        }
    };

    const handleDelete = async (photoId) => {
        if (!window.confirm("Eliminar foto?")) return;
        try {
            await removePhoto(photoId);
            await loadPhotos();
        } catch (err) {
            alert(err.message || "No se pudo eliminar");
        }
    };

    return (
        <div className="bf-wrap">
            <div className="bf-head">
                <div>
                    <h5 className="bf-title">Biblioteca</h5>
                    <small className="bf-sub">Fotos del paciente</small>
                </div>
                <div className="bf-meta">
                    <span className="bf-badge">{photos.length} fotos</span>
                    <button className="btn btn-outline-secondary btn-sm" onClick={loadPhotos} disabled={loading}>
                        <i className="fas fa-sync-alt"></i>
                    </button>
                    <button className="btn btn-primary btn-sm" onClick={() => fileRef.current?.click()} disabled={!recordID || loading}>
                        <i className="fas fa-upload mr-1"></i> Subir
                    </button>
                    <input
                        type="file"
                        ref={fileRef}
                        hidden
                        multiple
                        accept="image/*"
                        onChange={handleUpload}
                    />
                </div>
            </div>

            {!recordID && (
                <div className="alert alert-warning mb-3 py-2">
                    Guarda el paciente para habilitar la carga de fotos.
                </div>
            )}

            {loading && (
                <div className="bf-loading">
                    <div className="spinner-border spinner-border-sm text-primary mr-2" role="status"></div>
                    Cargando...
                </div>
            )}

            {!loading && photos.length === 0 && (
                <div className="bf-empty">
                    <i className="far fa-images"></i>
                    <span>No hay fotos cargadas.</span>
                </div>
            )}

            <div className="bf-grid">
                {photos.map((p) => (
                    <div className="bf-card" key={p.fotoID}>
                        <img src={HOST + p.url} className="bf-img" alt={p.nombreArchivo || "foto"} />
                        {p.isCover ? <span className="bf-cover">Portada</span> : null}
                        <div className="bf-actions">
                            <button
                                className={`btn btn-sm ${p.isCover ? "btn-success" : "btn-outline-success"}`}
                                onClick={() => handleSetCover(p.fotoID)}
                                title={p.isCover ? "Foto portada" : "Marcar portada"}
                            >
                                <i className="fas fa-star"></i>
                            </button>
                            <a
                                href={HOST + p.url}
                                download
                                target="_blank"
                                rel="noreferrer"
                                className="btn btn-outline-info btn-sm"
                                title="Descargar"
                            >
                                <i className="fas fa-download"></i>
                            </a>
                            <button
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => handleDelete(p.fotoID)}
                                title="Eliminar"
                            >
                                <i className="fas fa-trash-alt"></i>
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
